import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/home',
    name: 'home',
    redirect: '/home/myUser',
    component: () => import('@/views/home.vue'),
    children:[
      {
        path: 'myUser',
        name: 'myUser',
        component: () => import('@/views/myUser.vue')
      },
      {
        path: 'myPromoter',
        name: 'myPromoter',
        component: () => import('@/views/myPromoter.vue')
      },
    ]
  },
  {
    path: '/mySet',
    name: 'mySet',
    component: () => import('@/views/mySet.vue')
  },
  {
    path: '/changePas',
    name: 'changePas',
    component: () => import('@/views/changePas.vue')
  },
  {
    path: '/myCard',
    name: 'myCard',
    component: () => import('@/views/myCard.vue')
  },
  {
    path: '/addCard',
    name: 'addCard',
    component: () => import('@/views/addCard.vue')
  },
  {
    path: '/historyList',
    name: 'historyList',
    component: () => import('@/views/historyList.vue')
  },
  {
    path: '/myDetails',
    name: 'myDetails',
    component: () => import('@/views/myDetails.vue')
  },
]

const router = new VueRouter({
  routes
})
const routerArray = ['/home','/mySet','/changePas','/myCard','/addCard','/historyList','/myDetails','/home/myUser','/home/myPromoter']
router.beforeEach((to, from, next)=>{
  if(to.path == '/') {
    if(localStorage.getItem('ttyh-agents')) {
      next('/home/myUser')
    }
  }
  routerArray.forEach((item,index)=>{
    if(to.path == item) {
      if(!localStorage.getItem('ttyh-agents')) {
        next('/')
      }
    }
  })
  next()
})

export default router
